import React, { useState, useEffect } from "react";

import "./configEditor.css";

const ConfigEditor = ({
  activeVersionId,
  config,
  handleUpdateConfiguration,
  handleCancel
}) => {
  const [configInEdit, setConfigInEdit] = useState({ ...config });

  // switches
  const handleIsOrdersAllowedChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.isOrdersAllowed = e.target.checked;
    setConfigInEdit({ ...workingObject });
  };
  const handleIsSMSAllowedChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.isSMSAllowed = e.target.checked;
    setConfigInEdit({ ...workingObject });
  };
  const handleIsOnlinePaymentAllowedChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.isOnlinePaymentAllowed = e.target.checked;
    setConfigInEdit({ ...workingObject });
  };
  const handleIsDeliveryAllowedChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.isDeliveryAllowed = e.target.checked;
    setConfigInEdit({ ...workingObject });
  };

  // order min sum for delivery
  const handleDeliveryOrderMinPriceInputChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.deliveryOrderMinPrice = e.target.value;
    setConfigInEdit({ ...workingObject });
  };

  // delivery price
  const handleDeliveryPriceInputChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.deliveryPrice = e.target.value;
    setConfigInEdit({ ...workingObject });
  };

  const handleDeliveryPriceInputChange2 = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.deliveryPrice2 = e.target.value;
    setConfigInEdit({ ...workingObject });
  };

  // free delivery min price
  const handleFreeDeliveryMinPriceInputChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.freeDeliveryMinPrice = e.target.value;
    setConfigInEdit({ ...workingObject });
  };

  // holidays
  const switchDayName = (day) => {
    switch (day.toString()) {
      case "0":
        return "Sunday";
      case "1":
        return "Monday";
      case "2":
        return "Tuesday";
      case "3":
        return "Wednesday";
      case "4":
        return "Thursday";
      case "5":
        return "Friday";
      case "6":
        return "Saturday";
    }
  };

  const daysOfWeek = ["1", "2", "3", "4", "5", "6", "0"];

  const handleHolidaysInputChange = (e) => {
    let workingObject = { ...configInEdit };
    if (!workingObject.holidays) {
      workingObject.holidays = [];
    }
    if (workingObject.holidays.indexOf(e.target.value) === -1) {
      workingObject.holidays = [...workingObject.holidays, e.target.value];
    } else {
      workingObject.holidays = workingObject.holidays.filter(
        (d) => d !== e.target.value
      );
    }

    setConfigInEdit({ ...workingObject });
  };

  // time input
  const handleOperationTimeToChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.operationTimeTo = e.target.value;
    setConfigInEdit({ ...workingObject });
  };
  const handleOperationTimeFromChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.operationTimeFrom = e.target.value;
    setConfigInEdit({ ...workingObject });
  };

  const handleOrderMakeFromChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.orderMakeFrom = e.target.value;
    setConfigInEdit({ ...workingObject });
  };
  const handleOrderMakeEatInToChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.orderMakeEatInTo = e.target.value;
    setConfigInEdit({ ...workingObject });
  };
  const handleOrderMakeTakeOutToChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.orderMakeTakeOutTo = e.target.value;
    setConfigInEdit({ ...workingObject });
  };

  const handleOrderGrabEatInFromChange = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.orderGrabEatInFrom = e.target.value;
    setConfigInEdit({ ...workingObject });
  };
  const handleOrderGrabEatInTo = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.orderGrabEatInTo = e.target.value;
    setConfigInEdit({ ...workingObject });
  };
  const handleOrderGrabDeliveryTo = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.orderGrabDeliveryTo = e.target.value;
    setConfigInEdit({ ...workingObject });
  };

  const handleOrderGrabTakeOutFrom = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.orderGrabTakeOutFrom = e.target.value;
    setConfigInEdit({ ...workingObject });
  };
  const handleOrderGrabTakeOutTo = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.orderGrabTakeOutTo = e.target.value;
    setConfigInEdit({ ...workingObject });
  };
  const handleOrderGrabTakeOutPayOnlineTo = (e) => {
    let workingObject = { ...configInEdit };
    workingObject.orderGrabTakeOutPayOnlineTo = e.target.value;
    setConfigInEdit({ ...workingObject });
  };

  return (
    <div className="configSection__configContainer">
      <div className="configContainer__switchesDiv">
        <h3>CONFIGURATIONS</h3>
        <div>
          <div className="switchesDiv__isOrdersAllowed">
            <h4>Online orders</h4>
            <div>
              <span>{configInEdit.isOrdersAllowed ? "on" : "off"}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  id="isOrdersAllowed"
                  name="isOrdersAllowed"
                  onChange={handleIsOrdersAllowedChange}
                  checked={configInEdit.isOrdersAllowed}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <div className="switchesDiv__isSMSAllowed">
            <h4>SMS notifications</h4>
            <div>
              <span>{configInEdit.isSMSAllowed ? "on" : "off"}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  id="isSMSAllowed"
                  name="isSMSAllowed"
                  onChange={handleIsSMSAllowedChange}
                  checked={configInEdit.isSMSAllowed}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <div className="switchesDiv__isOnlinePaymentAllowed">
            <h4>Online payment</h4>
            <div>
              <span>{configInEdit.isOnlinePaymentAllowed ? "on" : "off"}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  id="isOnlinePaymentAllowed"
                  name="isOnlinePaymentAllowed"
                  onChange={handleIsOnlinePaymentAllowedChange}
                  checked={configInEdit.isOnlinePaymentAllowed}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <div className="switchesDiv__isDeliveryAllowed">
            <h4>Delivery</h4>
            <div>
              <span>{configInEdit.isDeliveryAllowed ? "on" : "off"}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  id="isDeliveryAllowed"
                  name="isDeliveryAllowed"
                  onChange={handleIsDeliveryAllowedChange}
                  checked={configInEdit.isDeliveryAllowed}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div>
          <div className="switchesDiv__freeDeliveryMinPrice">
            <h4>Min sum for delivery</h4>
            <input
              className="freeDeliveryMinPrice__input"
              type="number"
              id="freeDeliveryMinPrice"
              name="freeDeliveryMinPrice"
              onChange={handleDeliveryOrderMinPriceInputChange}
              value={configInEdit.deliveryOrderMinPrice}
            />
            &nbsp;$
          </div>
          <div className="switchesDiv__freeDeliveryMinPrice">
            <h4>Delivery price (zone 1)</h4>
            <input
              className="freeDeliveryMinPrice__input"
              type="number"
              id="freeDeliveryMinPrice"
              name="freeDeliveryMinPrice"
              onChange={handleDeliveryPriceInputChange}
              value={configInEdit.deliveryPrice}
            />
            &nbsp;$
          </div>
          <div className="switchesDiv__freeDeliveryMinPrice">
            <h4>Delivery price (zone 2)</h4>
            <input
              className="freeDeliveryMinPrice__input"
              type="number"
              id="freeDeliveryMinPrice2"
              name="freeDeliveryMinPrice2"
              onChange={handleDeliveryPriceInputChange2}
              value={configInEdit.deliveryPrice2}
            />
            &nbsp;$
          </div>
          <div className="switchesDiv__freeDeliveryMinPrice">
            <h4>Min sum for free delivery</h4>
            <input
              className="freeDeliveryMinPrice__input"
              type="number"
              id="freeDeliveryMinPrice"
              name="freeDeliveryMinPrice"
              onChange={handleFreeDeliveryMinPriceInputChange}
              value={configInEdit.freeDeliveryMinPrice}
            />
            &nbsp;$
          </div>
        </div>
      </div>
      <div className="configContainer__holidaysDiv">
        <h3 style={{ textAlign: "center" }}>HOLIDAYS</h3>
        <div className="holidaysDiv__daysContainer">
          {daysOfWeek.map((day) => (
            <label key={day} htmlFor={switchDayName(day)}>
              {switchDayName(day)}
              <input
                type="checkbox"
                id={switchDayName(day)}
                value={day}
                checked={configInEdit.holidays.indexOf(day.toString()) !== -1}
                onChange={handleHolidaysInputChange}
              />
            </label>
          ))}
        </div>
      </div>
      <div className="configContainer__TimeInputDiv">
        <h3>TIME CONFIGURATION</h3>
        <div className="TimeInputDiv__operationTime">
          <h4>Restaurant working hours</h4>
          <div className="operationTime__from">
            <span className="helperSpan">from</span>
            <input
              type="time"
              name="operationTimeFrom"
              id="operationTimeFrom"
              onChange={handleOperationTimeFromChange}
              value={configInEdit.operationTimeFrom}
            />
          </div>
          <div className="operationTime__to">
            <span className="helperSpan">to</span>
            <input
              type="time"
              name="operationTimeTo"
              id="operationTimeTo"
              onChange={handleOperationTimeToChange}
              value={configInEdit.operationTimeTo}
            />
          </div>
        </div>
        <div className="TimeInputDiv__orderMake">
          <h4>Order accept</h4>
          <div className="orderMake__from">
            <span className="helperSpan">from</span>
            <input
              type="time"
              name="orderMakeFrom"
              id="orderMakeFrom"
              onChange={handleOrderMakeFromChange}
              value={configInEdit.orderMakeFrom}
            />
          </div>
          <div className="orderMake__eatInTo">
            <span className="helperSpan">on spot to</span>
            <input
              type="time"
              name="orderMakeEatInTo"
              id="orderMakeEatInTo"
              onChange={handleOrderMakeEatInToChange}
              value={configInEdit.orderMakeEatInTo}
            />
          </div>
          <div className="orderMake__takeOutTo">
            <span className="helperSpan">takeaway to</span>
            <input
              type="time"
              name="orderMakeTakeOutTo"
              id="orderMakeTakeOutTo"
              onChange={handleOrderMakeTakeOutToChange}
              value={configInEdit.orderMakeTakeOutTo}
            />
          </div>
        </div>
        <div className="TimeInputDiv__orderGrabEatIn">
          <h4>Order receipt (on spot)</h4>
          <div className="orderGrabEatIn__from">
            <span className="helperSpan">from</span>
            <input
              type="time"
              name="orderGrabEatInFrom"
              id="orderGrabEatInFrom"
              onChange={handleOrderGrabEatInFromChange}
              value={configInEdit.orderGrabEatInFrom}
            />
          </div>
          <div className="orderGrabEatIn__to">
            <span className="helperSpan">to</span>
            <input
              type="time"
              name="orderGrabEatInTo"
              id="orderGrabEatInTo"
              onChange={handleOrderGrabEatInTo}
              value={configInEdit.orderGrabEatInTo}
            />
          </div>
        </div>
        <div className="TimeInputDiv__orderGrabTakeOut">
          <h4>Order receipt (take away)</h4>
          <div className="orderGrabTakeOut__from">
            <span className="helperSpan">from</span>
            <input
              type="time"
              name="orderGrabTakeOutFrom"
              id="orderGrabTakeOutFrom"
              onChange={handleOrderGrabTakeOutFrom}
              value={configInEdit.orderGrabTakeOutFrom}
            />
          </div>
          <div className="orderGrabTakeOut__onSpotTo">
            <span className="helperSpan">on-spot payment to</span>
            <input
              type="time"
              name="orderGrabTakeOutTo"
              id="orderGrabTakeOutTo"
              onChange={handleOrderGrabTakeOutTo}
              value={configInEdit.orderGrabTakeOutTo}
            />
          </div>
          <div className="orderGrabTakeOut__payOnlineTo">
            <span className="helperSpan">online payment to</span>
            <input
              type="time"
              name="orderGrabTakeOutPayOnlineTo"
              id="orderGrabTakeOutPayOnlineTo"
              onChange={handleOrderGrabTakeOutPayOnlineTo}
              value={configInEdit.orderGrabTakeOutPayOnlineTo}
            />
          </div>
        </div>
        <div className="TimeInputDiv__orderGrabTakeOut">
          <h4>Order receipt (delivery)</h4>
          <div className="orderGrabTakeOut__from">
            <span className="helperSpan">from</span>
            <input
              readOnly={true}
              type="time"
              name="orderGrabTakeOutFrom2"
              id="orderGrabTakeOutFrom2"
              value={configInEdit.orderGrabTakeOutFrom}
            />
          </div>
          <div className="orderGrabTakeOut__to">
            <span className="helperSpan">to</span>
            <input
              type="time"
              name="orderGrabDeliveryTo"
              id="orderGrabDeliveryTo"
              onChange={handleOrderGrabDeliveryTo}
              value={configInEdit.orderGrabDeliveryTo}
            />
          </div>
        </div>
      </div>
      <div className="configContainer__controlsDiv">
        <button
          className="controlsDiv__saveConfigBtn"
          onClick={() => handleUpdateConfiguration(configInEdit)}
        >
          SAVE
        </button>
        <button
          className="controlsDiv__cancelConfigBtn"
          onClick={() => handleCancel()}
        >
          CANCEL
        </button>
      </div>
    </div>
  );
};

export default ConfigEditor;
